module.exports = __webpack_public_path__ + "img/shgs.b0c1f3b6.png";